<template>
  <Carousel v-bind="createProps">
    <template v-if="checkLayoutMatch('layout_2')" #bottomBar="slotProps">
      <Footer :title="getTitleFromSlotProp(slotProps)" :content="getTextFromSlotProp(slotProps)" />
    </template>
  </Carousel>
</template>

<script>
import Carousel from '@/components/Common/Carousel';
import Footer from '@/components/Prismic/Landings/Slices/CarouselCustom/Footer';
export default {
  components: {
    Carousel,
    Footer
  },
  props: {
    slice: {
      type: Object,
      required: true
    }
  },
  data() {
    return {
      items: []
    };
  },
  async fetch() {
    this.items = this.slice.items.map((item, idx) => {
      return {
        image: item.image.url,
        name: item.image.alt,
        link: item.link[0]?.text || '',
        internalLink: item.internal_link,
        id: idx,
        width: item.image.dimensions.width,
        height: item.image.dimensions.height,
        title: item.title1,
        text: item.text,
        linkColor: item.text_link_color
      };
    });
  },
  computed: {
    currentLayout() {
      return this.slice.slice_label;
    },
    createProps() {
      return {
        ...{ items: this.items, customImages: true, height: 180, marginRight: 20 },
        ...(this.checkLayoutMatch('layout_2')
          ? {
              marginRight: 15,
              marginBottom: 10,
              borderRadius: 10,
              showShadow: true,
              showBottomBar: true,
              showBottomSeeMore: false,
              layout2: true
            }
          : {})
      };
    }
  },
  methods: {
    checkLayoutMatch(layout) {
      return this.currentLayout == layout;
    },
    getTitleFromSlotProp(slotProps) {
      return slotProps.data.title[0]?.text || '';
    },
    getTextFromSlotProp(slotProps) {
      return slotProps.data.text[0]?.text || '';
    }
  }
};
</script>
